import React from 'react';
import { Create } from 'react-admin';
import { t } from 'i18next';
import CustomCreateToolbar from '../CustomCreateToolbar';
import { NutrientElementForm } from './NutrientElementForm';

export const NutrientElementCreate = props => (
  <Create {...props} title={t("nutrient_elements.title_create")}>
    <NutrientElementForm toolbar={<CustomCreateToolbar user={props.options.currentUser.role}/>}/>
  </Create>
);
